import { Chip } from '@mui/material';

const RISK_CONFIG = {
  CRITICAL: { bg: '#d32f2f' },
  HIGH:     { bg: '#f57c00' },
  MEDIUM:   { bg: '#f9a825' },
  LOW:      { bg: '#388e3c' },
};

const RiskBadge = ({ risk = 'LOW', size = 'small' }) => {
  const cfg = RISK_CONFIG[risk] ?? RISK_CONFIG.LOW;
  return (
    <Chip
      label={risk}
      size={size}
      sx={{
        bgcolor: cfg.bg,
        color: '#text.primary',
        fontWeight: 500,
        fontSize: size === 'small' ? '0.65rem' : '0.75rem',
        borderRadius: 1,
        height: size === 'small' ? 20 : 24,
      }}
    />
  );
};

export default RiskBadge;
